import {Box, BoxProps} from '@chakra-ui/react'

export const bleedSize = '1.5rem'
export const negativeBleed = '-1.5rem'

export default function PartialBleed(p: BoxProps) {
  return (
    <Box
      ml={{base: 0, md: negativeBleed}}
      mr={{base: 0, md: negativeBleed}}
      {...p}
    />
  )
}
